import React, { useState, useEffect } from "react";
import RequestService from "../services/RequestService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format, differenceInHours } from "date-fns";
import DeliverModalMobile from './modals/DeliverModalMobile';
import RequestDetailsModalMobile from "./modals/RequestDetailsModalMobile";
import { FaLongArrowAltDown } from "react-icons/fa";
import { isSLAPassed, isSLANear, isSLATwoHour } from "../utils/SLACalcs";
import StatusRequests from '../enums/StatusRequests';
import { RiTimerLine } from "react-icons/ri";
import { startPolling } from "../utils/polling";


export default function RouteDeliveryTelaEntregador() {

  const [deliverModal, setDeliverModal] = useState(false);
  const [requestOnDeliverModal, setRequestOnDeliverModal] = useState();
  const [requestNroOnDeliverModal, setRequestNroOnDeliverModal] = useState();

  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();

  const [requestListRota, setRequestListRota] = useState({ requests: [], totalPages: 1 });
  const [currentPageRota, setCurrentPageRota] = useState(1);


  useEffect(() => {

    // Função para buscar os requests
    const fetchRequests = async () => {
      const status = 'ROTA DE ENTREGA'
      const params = new URLSearchParams();
      if (status) params.append('status', status);

      const queryString = params.toString();
      const requestsRota = await RequestService.getRequestsEntregador(`?${queryString}`, currentPageRota);
      setRequestListRota(requestsRota);
    };

    // Chamada inicial
    const fetchData = () => {
      fetchRequests();
    };

    fetchData()

    return startPolling(fetchData);

  }, [currentPageRota, deliverModal]);

  const handlePageChangeRota = (newPage) => {
    if (newPage >= 1 && newPage <= requestListRota.totalPages) {
      setCurrentPageRota(newPage);
    }
  };

  const handleEntregar = async (ticketId,requestNro) => {
    setDeliverModal(true)
    setRequestOnDeliverModal(ticketId)
    setRequestNroOnDeliverModal(requestNro)
  };

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  return (
    <div className="flex w-full h-full justify-center items-center sm:p-4 bg-gray-200">

      <div className="flex flex-col w-full h-full sm:rounded-xl sm:py-8 sm:px-6 gap-12 bg-white">

        <div className="flex flex-col w-full h-full gap-4 sm:border sm:border-gray-800 sm:border-opacity-40 sm:rounded-xl sm:p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-4">
            <FaCircle
              className="animate-pulse"
              color={StatusRequests["ROTA DE ENTREGA"]?.cor}
              size={15}
            />
            ROTA DE ENTREGA
          </div>

          <div className="flex flex-col justify-between w-full h-full">
            <div className="flex flex-col gap-4">

              {/* OLD BUT WORKING*/}
              {/* <div className="overflow-x-auto">
                <table className="min-w-full bg-white sm:rounded-lg text-[10px]">
                  <thead className="bg-[#38bdf8]">
                    <tr>
                      <th className="py-2 px-4 border-b sm:rounded-tl-lg">ID</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Cidade</th>
                      <th className="py-2 px-4 border-b">Qtd</th>
                      <th className="py-2 px-4 border-b">Técnico</th>
                      <th className="py-2 px-4 border-b">Obs Entrega</th>
                      <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                      <th className="py-2 px-4 border-b sm:rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {requestListRota.requests?.map((request, index) => (
                      <tr
                        key={`request-${index}`}
                        className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                          ? "bg-red-100"
                          : isSLANear(request.slaDate)
                            ? "bg-yellow-100"
                            : isSLATwoHour(request.slaDate)
                              ? "bg-yellow-200"
                              : ""
                          }`}
                      >
                        <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={() => handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico} - {request.telefone}</div></td>
                        <td className="py-1 px-4">{request.ultimaObs}</td>
                        <td
                          className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                            ? "text-red-500 font-bold"
                            : request?.slaDate && isSLANear(request.slaDate)
                              ? "text-yellow-600 font-bold"
                              : request?.slaDate && isSLATwoHour(request.slaDate)
                                ? "text-yellow-600 font-bold animate-pulse-fast"
                                : ""
                            }`}
                        >
                          <div className="flex gap-1 items-center font-bold">
                            {request?.slaDate
                              ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                              : "N/A"}
                            {request?.slaDate && isSLATwoHour(request.slaDate) && (
                              <RiTimerLine size={12} />
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2 h-5 text-[11px]">
                            <button
                              className=" bg-sky-700 rounded-full px-2 text-white whitespace-nowrap"
                              onClick={() => handleEntregar(request._id, request.idRequest)}
                            >
                              Informar Entrega
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                   
                  </tbody>
                </table>
              </div> */}

              {/* MOBILE: Cards para cada request */}
              <div className="block sm:hidden w-full">
                {requestListRota.requests?.map((request, index) => (
                  <div
                    key={`request-mobile-${index}`}
                    className={`mb-3 p-3 rounded-lg shadow border
                    ${isSLAPassed(request.slaDate)
                        ? "bg-red-100"
                        : isSLANear(request.slaDate)
                          ? "bg-yellow-100"
                          : isSLATwoHour(request.slaDate)
                            ? "bg-yellow-200"
                            : "bg-white"
                        }`}
                  >
                    <div className="flex justify-between items-center mb-1">
                      <span className="font-bold text-xs">ID:</span>
                      <span
                        className="underline font-bold text-xs cursor-pointer"
                        onClick={() => handleRequestDetailsModal(request._id)}
                      >
                        {request.idRequest}
                      </span>
                      <button
                        className="bg-sky-700 rounded-full px-2 py-1 text-white text-xs"
                        onClick={() => handleEntregar(request._id, request.idRequest)}
                      >
                        Entregar
                      </button>
                    </div>
                    <div className="flex flex-wrap gap-x-2 text-[11px]">
                      <div><span className="font-semibold">Cod Sap:</span> {request.codSap}</div>
                      <div><span className="font-semibold">Cidade:</span> {request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</div>
                      <div><span className="font-semibold">Qtd:</span> {request.quantidadeAtender}</div>
                      <div><span className="font-semibold">Técnico:</span> {request.tecnico} - {request.telefone}</div>
                      <div><span className="font-semibold">Obs:</span> {request.ultimaObs}</div>
                      <div className={`font-semibold ${isSLAPassed(request.slaDate) ? "text-red-500" : isSLANear(request.slaDate) ? "text-yellow-600" : ""}`}>
                        SLA: {request?.slaDate ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm") : "N/A"}
                        {request?.slaDate && isSLATwoHour(request.slaDate) && <RiTimerLine size={12} className="inline ml-1" />}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* DESKTOP: Mantém a tabela para telas sm+ */}
              <div className="overflow-x-auto hidden sm:block">
                <table className="min-w-full bg-white sm:rounded-lg text-[10px]">
                  <thead className="bg-[#38bdf8]">
                    <tr>
                      <th className="py-2 px-4 border-b sm:rounded-tl-lg">ID</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Cidade</th>
                      <th className="py-2 px-4 border-b">Qtd</th>
                      <th className="py-2 px-4 border-b">Técnico</th>
                      <th className="py-2 px-4 border-b">Obs Entrega</th>
                      <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                      <th className="py-2 px-4 border-b sm:rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestListRota.requests?.map((request, index) => (
                      <tr
                        key={`request-${index}`}
                        className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                          ? "bg-red-100"
                          : isSLANear(request.slaDate)
                            ? "bg-yellow-100"
                            : isSLATwoHour(request.slaDate)
                              ? "bg-yellow-200"
                              : ""
                          }`}
                      >
                        <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={() => handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico} - {request.telefone}</div></td>
                        <td className="py-1 px-4">{request.ultimaObs}</td>
                        <td
                          className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                            ? "text-red-500 font-bold"
                            : request?.slaDate && isSLANear(request.slaDate)
                              ? "text-yellow-600 font-bold"
                              : request?.slaDate && isSLATwoHour(request.slaDate)
                                ? "text-yellow-600 font-bold animate-pulse-fast"
                                : ""
                            }`}
                        >
                          <div className="flex gap-1 items-center font-bold">
                            {request?.slaDate
                              ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                              : "N/A"}
                            {request?.slaDate && isSLATwoHour(request.slaDate) && (
                              <RiTimerLine size={12} />
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2 h-5 text-[11px]">
                            <button
                              className=" bg-sky-700 rounded-full px-2 text-white whitespace-nowrap"
                              onClick={() => handleEntregar(request._id, request.idRequest)}
                            >
                              Informar Entrega
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                className={`px-2 py-1 rounded-md ${currentPageRota === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeRota(currentPageRota - 1)}
                disabled={currentPageRota === 1}
              >
                {'<'}
              </button>
              {[...Array(requestListRota.totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`px-2 py-1 rounded-md ${currentPageRota === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeRota(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className={`px-2 py-1 rounded-md ${currentPageRota === requestListRota.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeRota(currentPageRota + 1)}
                disabled={currentPageRota === requestListRota.totalPages}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

      </div>

      { requestOnDeliverModal && 
      <div className="absolute">
        <DeliverModalMobile
          isModalOpen={deliverModal}
          setModalOpen={() => {
            setDeliverModal(!deliverModal);
          }}
          requestId={requestOnDeliverModal}
          requestNro={requestNroOnDeliverModal}
          // setTicketCb={setTicket}
        ></DeliverModalMobile>
      </div>
      }

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModalMobile
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            // setTicketCb={setTicket}
          ></RequestDetailsModalMobile>
        </div>
      }

    </div>
  )
}
